
  import { Component, Vue, Prop } from 'vue-property-decorator';

  @Component
  export default class ContentPanel extends Vue {
    @Prop() private heading!: string;
    @Prop() private loading!: boolean;
  }
